import { axiosReq } from "@/lib/axios";
import { queryClient } from "@/lib/react-query" 
import { useMutation } from "@tanstack/react-query";
// import posthog from "posthog-js";
import { toast } from "sonner";

type ImageCarouselArgs = {
  post_id: number,
  story_id: number,
  imageIds: number[] | null
}

export const useEditImageCarousel = () => {

  const request = async ({ imageIds, post_id, story_id }: ImageCarouselArgs) => {
    const response = await axiosReq.post('/api/landing/image-carousel/', {
      event_id: post_id,
      story_id: story_id,
      image_id: imageIds
    })

    return response.data
  }

  const { mutate: editImageCarousel, mutateAsync: editCarouselAsync ,status } = useMutation({
    mutationFn: request,
    onSuccess: () => {
      toast.message("Images connected to post")
      queryClient.invalidateQueries({
        queryKey: ["schedule_posts"]
      })
      queryClient.invalidateQueries({
        queryKey: ["theme-details"]
      })
    }
  })

  return { editImageCarousel, editCarouselAsync ,status }
}


export const useSaveImage = () => {
  const request = async (data: { event_id: number, image_id: number, story_id: number }) => {
    const response = await axiosReq.post('/api/approval/save-image-post/', data);
    return response.data
  }

  const { mutate: saveImage, status } = useMutation({
    mutationFn: request,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schedule_posts"] })
      queryClient.invalidateQueries({ queryKey: ["socials-unreviewed"] })
      queryClient.invalidateQueries({ queryKey: ["themes"] })
      queryClient.invalidateQueries({ queryKey: ["theme-details"] })
    }
  })

  return { saveImage, status }

}
